import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  isNullData : false
};

const slice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    // * START LOADING,
    startLoading(state) {
      state.isLoading = true;
    },
    // * SET NULL DATA
    setIsNullData(state, action) {
      state.isNullData = action.payload;
    },
    setIsNullDataFalse(state) {
      state.isNullData = false;
    },
    setIsNullDataTrue(state) {
      state.isNullData = true;
    }
  },
});

export const { startLoading, setIsNullData, setIsNullDataFalse, setIsNullDataTrue } = slice.actions;
    
export default slice.reducer;